import { render, staticRenderFns } from "./PaymentCheckout.vue?vue&type=template&id=264f6b6d&scoped=true&"
import script from "./PaymentCheckout.vue?vue&type=script&lang=js&"
export * from "./PaymentCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f6b6d",
  null
  
)

export default component.exports